/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

// Trusted origins that the Card Isle iframe can post messages from.
// Production is served from www.cardisle.com; UAT is served from uat-1-cardisle.18f.tech.
export const CARD_ISLE_ALLOWED_ORIGINS = [
    'https://www.cardisle.com',
    'https://uat-1-cardisle.18f.tech',
];

export const isCardIsleOrigin = (origin) => CARD_ISLE_ALLOWED_ORIGINS.includes(origin);
